import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Typography } from 'antd'
import backgroundImage from 'src/assets/images/background-page.png'
import secureAccessImage from 'src/assets/images/secure-access.png'
import bfaLogo from 'src/assets/images/bfa-logo.png'
import { colorTextSubtlest } from 'src/app/themes/primaryThemeDefault'
import './logout.scss'

const LockUserPage: React.FC = (props: PropsWithChildren) => {
  const { t } = useTranslation()

  return (
    <div
      className='page-container'
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
      }}
    >
      <img className='page-logo' src={bfaLogo} alt='logo' />{' '}
      <Card className='page-card' bordered={false}>
        <img src={secureAccessImage} alt='secure-access-inactivity' />
        <Typography.Title level={1} style={{ textAlign: 'center', lineHeight: '38px', fontSize: '28px' }}>
          {t('common:locked_user')}
        </Typography.Title>

        <Typography.Text type='secondary' style={{ textAlign: 'center', color: colorTextSubtlest }}>
          {t('common:locked_user_message')}
        </Typography.Text>
      </Card>
    </div>
  )
}

export default LockUserPage
